import { useState } from "react";

import { WebinarCard } from "./components/WebinarCard";
import { StandardFormComponent } from "../components/FormComponent";

import { webinar } from "../../datasets/landingpages/webinarregistration/form";

import { InfoBox } from "../components/form/InfoBox";

export const WebinarRegistration = ({ post }) => {
  const [modalOpen, changeModalOpen] = useState(false);
  const [errorModalOpen, changeErrorModalOpen] = useState(false);

  return (
    <main>
      <section className="webinar_registration-main">
        {modalOpen && (
          <InfoBox
            closeModal={() => changeModalOpen(false)}
            title="Thank you for signing up"
            text="We will send you a calendar invite shortly."
          />
        )}
        {errorModalOpen && (
          <InfoBox
            closeModal={() => changeErrorModalOpen(false)}
            title="Oops, there was an error on our side"
            text="There was an unexpected internal error with our server. Please contact Demyst support."
            type="Error"
          />
        )}
        <section className="webinar_registration-summary">
          <WebinarCard
            loading={false}
            post={post?.body}
            showPresenter={post?.body?.should_show_presenter}
            showTable={post?.body?.should_show_upcoming_topics_table}
          />
        </section>
        <section className="webinar_registration-form">
          <section className="webinar_form-main">
            {post?.form?.title && <h2 className="webinar_form-header">{post?.form?.title}</h2>}
            <StandardFormComponent
              data={webinar}
              webinarIdZoom={post?.webinar_id_zoom}
              changeModalOpen={changeModalOpen}
              changeErrorModalOpen={changeErrorModalOpen}
              pipedriveType="Webinar Registration"
              formName="Webinar registration"
              gaName="Webinar Registration"
            />
          </section>
        </section>
      </section>
    </main>
  );
};
